export { VAvatarGroup } from './VAvatarGroup'
